export default {
  announcements: null,
  announcementsAll: null,
  isLoading: false,
  isSubmitting: false,
  errors: null,
  validationErrors: null,
};
